import { load } from '@fingerprintjs/fingerprintjs';
import { useDispatch } from '@client/hooks/redux.hooks';
import { useMountEffect } from '@client/hooks/utils.hooks';
import { setBrowserFingerprint, updatePosition } from '@client/slices/helpers/session.reducer';

export const useBrowserFingerprint = () => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    void load().then((fp) => {
      void fp.get().then(({ visitorId }) => {
        dispatch(setBrowserFingerprint(visitorId));
      });
    });

    if (window.navigator?.geolocation) {
      window.navigator.geolocation.watchPosition(
        ({ coords }) => dispatch(updatePosition(coords)), // success
        () => dispatch(updatePosition(null)), // error
      );
    }
  });
};
